// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"9fd609f7","60":"8846123d","122":"c34e5628","342":"3e540578","431":"edbd086c","453":"839761fb","584":"865eec71","690":"88431173","717":"da38fade","726":"a54a3cc7","794":"e81d76ec","913":"42cb8e36","926":"e9adc7ac","972":"2e45b6dc"}[chunkId] + ".chunk.js";
};